module.exports = __webpack_public_path__ + "statics/img/CoreComparison-shopify@2x.72c3acf1.png";